import type { ImageLabelProps } from 'src/components/atoms/ImageLabel/ImageLabel';
import { IconType, ImageLabelColor } from 'src/components/atoms/ImageLabel/ImageLabel';
import type { ProductState } from 'src/redux/product/types';

export const useImageLabel = ({
  attributes,
  availability,
  available,
  purchasable,
  salePercentage = 0,
}: ProductState): ImageLabelProps | null => {
  if (!available && availability === 'suspended') {
    return {
      color: ImageLabelColor.Grey,
      text: 'UNAVAILABLE',
    };
  }

  if (!purchasable) {
    return {
      color: ImageLabelColor.Grey,
      text: 'OUT OF STOCK',
    };
  }

  if (salePercentage && salePercentage > 0) {
    return {
      color: ImageLabelColor.Red,
      text: `${salePercentage}% OFF`,
    };
  }

  if (attributes?.starBrand) {
    return {
      color: ImageLabelColor.Purple,
      icon: IconType.Diamond,
      text: 'TOP BRAND',
    };
  }

  return null;
};
